// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"BreadCrumbs_root__rWoq1"};